import React from 'react';

export const CloseModalIcon = ({ onHandleClick }) => {
  return (
    <label type='button' onClick={onHandleClick} aria-label='Close'>
      <img src='/resources/close.png' alt='close' className='w-50' />
    </label>
  );
};
